import { connect } from "react-redux";
import React from "react";

import { ListBody, ListHeader } from "../../../components/UI/ListView";
import { setDynamicRouteConfiguration } from "../../../redux/actions/navbar";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../constants/aptihealth";
import { Text } from "../../../component-library";

const ScheduleInactive = (props) => {
  const _telClick = () => {
    window.open(SUPPORT_NUMBER_HREF);
  };
  const _emailClick = () => {
    window.open("mailto:support@aptihealth.com");
  };

  return (
    <>
      <div className="pt-2 position-relative">
        <ListBody>
          <ListHeader className="d-none d-lg-block" title="Schedule" />
          <div className="patient-schedule-inactive--aligner">
            <div className="patient-schedule-inactive--fixed">
              <Text className="d-block text-center m-3" type="heading-1">
                Your Account is Currently Inactive
              </Text>
              <div className="mx-3 text-center">
                <Text type="paragraph" color="grey">
                  Looking to schedule a session? Please email us at{" "}
                </Text>
                <Text className="patient-contact-link" type="paragraph" onClick={_emailClick}>
                  support@aptihealth.com
                </Text>
                <Text type="paragraph" color="grey">
                  {" "}
                  or call us at{" "}
                </Text>
                <Text className="patient-contact-link" type="paragraph" onClick={_telClick}>
                  {SUPPORT_NUMBER}
                </Text>
                .
              </div>
            </div>
          </div>
        </ListBody>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps, { setDynamicRouteConfiguration })(ScheduleInactive);
